module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_agder_neg.e41d0617.png";